import React from 'react';
import {BsTwitter, BsInstagram} from 'react-icons/bs';
import {FaFacebookF} from 'react-icons/fa';

const SocialMedia = () => {




  return <>
  <div className="app__social">
  <a href='https://twitter.com/KarthikNarve'>
    <div>
        <BsTwitter id='twit'/>
    </div>
    </a>
    <a href="https://www.instagram.com/karthik___jamadagni/">
    <div>
        <BsInstagram id='inst'/>
    </div>
    </a>
    <button style={{border: "none"}} onClick={()=>{alert("Facebook is currently inactive")}}>
    <div>
        <FaFacebookF id='fb'/>
    </div>
    </button>
  </div>
  </>
}

export default SocialMedia;
